// extracted by mini-css-extract-plugin
export default {"vpGrid":"ValueProps_vpGrid__B9M1i","vpCard":"ValueProps_vpCard__98Erg","ix":"ValueProps_ix__vWU4e","glyph":"ValueProps_glyph__dLXMP"};